import React from 'react';
import { Link } from 'react-router-dom';
import RouterUtils from '../../../../../routing/RouterUtils';
import { PsRoutes } from '../../../../../routing/Routes';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { LoginManagerInstance } from '../../../../../../login/LoginManager';
import { PsDropdown } from '../../../../ps-dropdown/PsDropdown';

export const InfoMenu = () => {
    const logout = () => {
        LoginManagerInstance.logout();
    };

    return (
        <PsDropdown icon="keyboard_arrow_down">
            <li>
                <Link to={RouterUtils.generateRoute(PsRoutes.PROFILE)}>
                    <i className="material-icons">person</i>{I18nUtils.tr('TR_PERFIL')}
                </Link>
            </li>
            <li className="divider"/>
            <li>
                <a onClick={logout} test-id="sidebar-logout">
                    <i className="material-icons">input</i>{I18nUtils.tr('TR_SALIR')}
                </a>
            </li>
        </PsDropdown>
    )
};

InfoMenu.propTypes = {};

InfoMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/user-info/info-menu/InfoMenu.jsx